import { createReducer, on } from '@ngrx/store';
import {
  BaseUrlEliquaCXChange,
  CloseEliquaCXEditIntegration,
  EditEliquaCXIntegrationSystem,
  EliquaCXSubmitData,
  IdpAccountEliquaCXChange,
  IntegrationCodeEliquaCXChange,
  NameEliquaCXChange,
  PasswordEliquaCXChange,
  SaveEliquaCXConfigurationFailed,
  SaveEliquaCXConfigurationSuccess,
  SchemaCodeEliquaCXChange,
  StatusEliquaCXChange,
  ToggleCredentialsConfHelpTextStatus,
  ToggleEndpointConfHelpTextStatus,
  ToggleRootConfHelpTextStatus,
  UpdateEliquaCXConfigurationSuccess,
  UsernameEliquaCXChange,
} from '../actions/eliqua-cx-configuration.actions';
import { CreateNewIntegration } from '../actions/integration-management-create-new.actions';

export interface EliquaCXConfigurationState {
  nameEliquaCX: string;
  integrationCodeEliquaCX: string;
  isActiveEliquaCX: boolean;
  schemaCodeEliquaCX: string;
  idpAccountEliquaCX: string;
  baseUrlEliquaCX: string;
  usernameEliquaCX: string;
  passwordEliquaCX: string;
  showUpdateBtn: boolean;
  showCancelBtn: boolean;
  disableName: boolean;
  disableIntegrationCode: boolean;
  rootConfigurationHelpTextStatus: boolean;
  credentialsConfigurationHelpTextStatus: boolean;
  endpointConfigurationHelpTextStatus: boolean;
  selectedEliquaCXDataFromGrid: any;
  isSubmittedData: boolean;
}

const initialState: EliquaCXConfigurationState = {
  nameEliquaCX: '',
  integrationCodeEliquaCX: '',
  isActiveEliquaCX: false,
  schemaCodeEliquaCX: '',
  idpAccountEliquaCX: '',
  baseUrlEliquaCX: '',
  usernameEliquaCX: '',
  passwordEliquaCX: '',
  showUpdateBtn: false,
  showCancelBtn: false,
  disableName: false,
  disableIntegrationCode: false,
  rootConfigurationHelpTextStatus: false,
  credentialsConfigurationHelpTextStatus: false,
  endpointConfigurationHelpTextStatus: false,
  selectedEliquaCXDataFromGrid: [],
  isSubmittedData: false,
};

export const EliquaCXConfigurationReducer = createReducer(
  initialState,
  on(CreateNewIntegration, () => initialState),
  on(NameEliquaCXChange, (state, { nameEliquaCX }) => ({
    ...state,
    nameEliquaCX,
  })),
  on(IntegrationCodeEliquaCXChange, (state, { integrationCodeEliquaCX }) => ({
    ...state,
    integrationCodeEliquaCX,
  })),
  on(StatusEliquaCXChange, (state, { isActiveEliquaCX }) => ({
    ...state,
    isActiveEliquaCX,
  })),
  on(SchemaCodeEliquaCXChange, (state, { schemaCodeEliquaCX }) => ({
    ...state,
    schemaCodeEliquaCX,
  })),
  on(IdpAccountEliquaCXChange, (state, { idpAccountEliquaCX }) => ({
    ...state,
    idpAccountEliquaCX,
  })),
  on(BaseUrlEliquaCXChange, (state, { baseUrlEliquaCX }) => ({
    ...state,
    baseUrlEliquaCX,
  })),
  on(UsernameEliquaCXChange, (state, { usernameEliquaCX }) => ({
    ...state,
    usernameEliquaCX,
  })),
  on(PasswordEliquaCXChange, (state, { passwordEliquaCX }) => ({
    ...state,
    passwordEliquaCX,
  })),
  on(SaveEliquaCXConfigurationSuccess, (state, { res }) => ({
    ...state,
    showUpdateBtn: true,
    disableName: true,
    disableIntegrationCode: true,
    nameEliquaCX: res.payload.data.integrationConfig?.integrationDisplayName,
    integrationCodeEliquaCX: res.payload.data.integrationCode,
    isActiveEliquaCX: res.payload.data.deleted,
    schemaCodeEliquaCX: res.payload.data.integrationConfig.schemaCode,
    idpAccountEliquaCX: res.payload.data.integrationConfig.idpAccount,
    baseUrlEliquaCX: res.payload.data.endpointConfiguration.endpointConfig?.baseURL,
    rootConfigurationHelpTextStatus: false,
    credentialsConfigurationHelpTextStatus: false,
    endpointConfigurationHelpTextStatus: false,
    isSubmittedData: false,
  })),
  on(SaveEliquaCXConfigurationFailed, (state) => ({
    ...state,
    showUpdateBtn: false,
    disableName: false,
    disableIntegrationCode: false,
  })),
  on(EditEliquaCXIntegrationSystem, (state, { eliquaCXData }) => ({
    ...state,
    nameEliquaCX: eliquaCXData.integrationConfig.integrationDisplayName,
    integrationCodeEliquaCX: eliquaCXData.integrationCode,
    isActiveEliquaCX: eliquaCXData.deleted,
    schemaCodeEliquaCX: eliquaCXData.integrationConfig.schemaCode,
    idpAccountEliquaCX: eliquaCXData.integrationConfig.idpAccount,
    baseUrlEliquaCX: eliquaCXData.endpointConfiguration.endpointConfig.baseURL,
    usernameEliquaCX: eliquaCXData.endpointConfiguration.credentialConfig.username,
    passwordEliquaCX: eliquaCXData.endpointConfiguration.credentialConfig.password,
    showUpdateBtn: true,
    disableName: true,
    disableIntegrationCode: true,
    showCancelBtn: true,
    isSubmittedData: false,
  })),
  on(UpdateEliquaCXConfigurationSuccess, (state, { res }) => ({
    ...state,
    showUpdateBtn: true,
    disableName: true,
    disableIntegrationCode: true,
    nameEliquaCX: res.payload.data.integrationConfig?.integrationDisplayName,
    integrationCodeEliquaCX: res.payload.data.integrationCode,
    isActiveEliquaCX: res.payload.data.deleted,
    schemaCodeEliquaCX: res.payload.data.integrationConfig.schemaCode,
    idpAccountEliquaCX: res.payload.data.integrationConfig.idpAccount,
    baseUrlEliquaCX: res.payload.data.endpointConfiguration.endpointConfig?.baseURL,
    usernameEliquaCX: res.payload.data.endpointConfiguration.credentialConfig.username,
    passwordEliquaCX: res.payload.data.endpointConfiguration.credentialConfig.password,
  })),
  on(ToggleRootConfHelpTextStatus, (state) => ({
    ...state,
    rootConfigurationHelpTextStatus: !state.rootConfigurationHelpTextStatus,
  })),
  on(ToggleEndpointConfHelpTextStatus, (state) => ({
    ...state,
    endpointConfigurationHelpTextStatus: !state.endpointConfigurationHelpTextStatus,
  })),
  on(ToggleCredentialsConfHelpTextStatus, (state) => ({
    ...state,
    credentialsConfigurationHelpTextStatus: !state.credentialsConfigurationHelpTextStatus,
  })),
  on(CloseEliquaCXEditIntegration, () => initialState),
  on(EliquaCXSubmitData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
);
